module.exports = __webpack_public_path__ + "img/2015020.dd66e800.svg";